var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwoColorUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u062D\\u0633\\u0627\\u0628_\\u06A9\\u0627\\u0631\\u0628\\u0631\\u06CC",
    "data-name": "\\u062D\\u0633\\u0627\\u0628 \\u06A9\\u0627\\u0631\\u0628\\u0631\\u06CC",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M0,0H16V16H0Z",
    fill: "none",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Mask",
    d: "M10.667,8.333a2.667,2.667,0,1,1,2.667-2.667A2.667,2.667,0,0,1,10.667,8.333Z",
    transform: "translate(-2.667 -1)",
    fill: "#fff",
    opacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Mask-Copy",
    d: "M3,17.8C3.259,14.618,5.841,13,8.989,13c3.192,0,5.814,1.529,6.01,4.8a.458.458,0,0,1-.5.533H3.485A.738.738,0,0,1,3,17.8Z",
    transform: "translate(-1 -4.333)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwoColorUser);
export default __webpack_public_path__ + "static/media/two-color-user.bfdf8a511dc4776fad3040d0a35dd4fc.svg";
export { ForwardRef as ReactComponent };